<template>
  <VDataGridV2
    :loader="dataLoader"
    :context-menu="CharacteristicUnitsService.contextMenu"
    sticky
    entity-type="characteristicUnit"
    @row:dblclick="openCard"
  >
    <VDataGridColumnV2
      id="id"
      label="id"
      width="50px"
      content-align="center"
    >
      <template #default="{ row }">
        <VLink
          @click="openCard(row)"
        >
          {{ row.id }}
        </VLink>
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
      id="name"
      label="Название"
      width="500px"
      filterable
      filter-send-name="pattern"
      :filter-props="{ placeholder: 'Название' }"
    >
      <template #default="{ row }">
        {{ row.name }}
      </template>
    </VDataGridColumnV2>

    <VDataGridActionBarV2>
      <VButton
        theme="primary"
        @click="openCard()"
      >
        Добавить ед. изм. характеристики
      </VButton>
    </VDataGridActionBarV2>
  </VDataGridV2>
</template>

<script lang="ts">

import CharacteristicUnit         from '@/domains/CharacteristicUnits/CharacteristicUnit';
import CharacteristicUnitsService from '@/domains/CharacteristicUnits/CharacteristicUnitsService';
import DataGridLoader             from '@/lib/components/VDataGridV2/DataGridLoader';

export default defineComponent({
  name: 'CharacteristicUnitsRegistry',

  data() {
    return {
      CharacteristicUnitsService,

      dataLoader: new DataGridLoader(CharacteristicUnitsService.getListPaginated),
    };
  },

  methods: {
    async openCard(row: CharacteristicUnit | null = null): Promise<void> {
      if (await CharacteristicUnitsService.showCard(row)) {
        this.dataLoader.refresh();
      }
    },
  },
});
</script>
